import React from 'react';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,
  Cell
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { themeColors, getSatisfactionColor, sqdDimensions } from '../../common/constants';


const SQDChart = ({ sqdChartData }) => {
  // If there's no data, show a message
  if (!sqdChartData || sqdChartData.length === 0) {
    return (
      <Box sx={{ 
        height: 300, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <Typography variant="body1" color="textSecondary">
          No SQD data available
        </Typography>
      </Box>
    );
  }

  // Custom tooltip to display on hover
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Box sx={{ 
          backgroundColor: 'white', 
          p: 2, 
          border: '1px solid #ccc',
          borderRadius: 1,
          boxShadow: 3
        }}>
          <Typography variant="subtitle2">
            {sqdDimensions[data.name] || data.name}
          </Typography>
          <Typography variant="body2">
            Score: <strong>{data.score.toFixed(2)}</strong>
          </Typography>
        </Box>
      );
    }
    return null;
  };

  return (
    <Box sx={{ width: '100%', height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={sqdChartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="name" 
            angle={-45} 
            textAnchor="end" 
            height={60}
            tick={{ fontSize: 12 }}
          />
          <YAxis 
            domain={[0, 5]} 
            tickCount={6} 
            tickFormatter={(value) => value.toFixed(1)}
            label={{ 
              value: 'Score', 
              angle: -90, 
              position: 'insideLeft',
              style: { textAnchor: 'middle' }
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend verticalAlign="top" />
          <Bar dataKey="score" name="SQD Score" barSize={30}>
            {sqdChartData.map((entry, index) => (
              <Cell 
                key={`cell-${index}`} 
                fill={getSatisfactionColor(entry.score)} 
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default SQDChart;